import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { AiOutlineEye } from "react-icons/ai";

import Logo from "../../../shared/components/Logo";
import FormButton from "../../../shared/components/form/FormButton";
import FormInput from "../../../shared/components/form/FormInput";
import authImage from "../../../assets/images/signup.png";
import useRegisterSchoolOwner from "../../../shared/api/registration/useRegisterSchoolOwner";

const OwnerDetails = () => {
  const navigate = useNavigate();

  const [passwordVisible, setPasswordVisible] = useState(false);

  const [account, setAccount] = useState({ accountType: "schoolowner" });
  const [request, loading] = useRegisterSchoolOwner();

  async function register(e) {
    e.preventDefault();

    await request(account);
  }

  return (
    <div className="auth_page">
      <div className="auth_page_content_grid">
        <div className="auth_logo_wrapper">
          <Logo />
        </div>

        <div className="auth_page_content">
          <h2 className="auth_page_title">Hello, Welcome to Get My Figures!</h2>

          <form onSubmit={register}>
            <FormInput
              label={"Last Name"}
              placeholder={"Enter last name"}
              required
              minLength={3}
              value={account?.lastName}
              onChange={(e) =>
                setAccount({ ...account, lastName: e.currentTarget.value })
              }
            />

            <FormInput
              label={"First Name"}
              placeholder={"Enter first name"}
              required
              minLength={3}
              value={account?.firstName}
              onChange={(e) =>
                setAccount({ ...account, firstName: e.currentTarget.value })
              }
            />

            <FormInput
              label={"Email Address"}
              placeholder={"Enter email address"}
              required
              minLength={6}
              type="email"
              value={account?.email || ""}
              onChange={(e) =>
                setAccount({
                  ...account,
                  email: e.currentTarget.value,
                })
              }
            />

            <FormInput
              label={"Phone Number"}
              placeholder={"Enter phone number"}
              required
              minLength={11}
              maxLength={11}
              value={account?.phone}
              onChange={(e) =>
                setAccount({ ...account, phone: e.currentTarget.value })
              }
            />

            <FormInput
              label={"Password"}
              placeholder={"Enter a strong password"}
              type={passwordVisible ? "text" : "password"}
              required
              minLength={6}
              value={account?.password || ""}
              rightIcon={<AiOutlineEye className="w-3 h-3 cursor-pointer" />}
              onClickRightIcon={() => setPasswordVisible(!passwordVisible)}
              onChange={(e) =>
                setAccount({
                  ...account,
                  password: e.currentTarget.value,
                })
              }
            />

            <FormButton
              title={"Create account"}
              className="mt-10"
              type="submit"
              loading={loading}
            />

            <p
              className="text-yankee_blue text-xs mt-2 cursor-pointer"
              onClick={() => navigate("/login")}
            >
              Already have an account?{" "}
              <span className="text-primary">Sign In</span>
            </p>
          </form>
        </div>
      </div>

      <div className="auth_page_image_grid">
        <div className="auth_image_container">
          <img src={authImage} alt="GMF" />
        </div>
      </div>
    </div>
  );
};
export default OwnerDetails;
